<template>
  <div>
    <StepBack />
    <v-row>
      <v-col cols="12">
        <h3>{{ stepHeader }}</h3>
      </v-col>

      <v-col cols="12">
        <v-alert color="#f6f7f9">
          <strong
            class="d-block"
            v-html="getString(stepContent, 'CVWizard_ImportentTips').Value"
          ></strong>
          <ul class="px-4">
            <li>
              {{
                getString(stepContent, 'CVWizard_ForthStep_ImportentTipsText')
                  .Value
              }}
            </li>
            <li>
              {{
                getString(stepContent, 'CVWizard_ForthStep_ImportentToKnow')
                  .Value
              }}
            </li>
          </ul>
        </v-alert>
      </v-col>
    </v-row>

    <v-form
      id="cvw-step-4"
      ref="cvw-form4"
      v-model="valid"
      class="rtl pa-0 mt-2"
      @keydown.enter="validate"
      v-if="!formSent"
    >
      <v-row>
        <!-- < Mil section > -->
        <div v-for="(service, i) in serviceData" :key="`service-${i}`">
          <v-col>
            <h3 class="display-26 mb-3">
              {{
                getString(
                  stepContent,
                  'CVWizard_ForthStep_MilitaryService_RadioButton'
                ).Value
              }}
              <span>#{{ i + 1 }}</span>
            </h3>
          </v-col>

          <v-col class="py-0">
            <RadioSelect
              :fieldLabel="[
                getString(
                  stepContent,
                  'CVWizard_ForthStep_MilitaryService_RadioButton'
                ).Value,
                getString(
                  stepContent,
                  'CVWizard_ForthStep_NationalService_RadioButton'
                ).Value,
              ]"
              :fieldIndex="i"
              :fieldValue="service.Service"
              @child-field="applyServiceTypeField"
              :isRow="true"
            />
          </v-col>

          <v-col cols="12" class="py-0">
            <v-row>
              <v-col cols="12" sm="6" class="py-0">
                <p class="display-18 font-weight-medium my-0">
                  {{ getString(stepContent, 'CVWizard_From').Value }}
                </p>
                <v-select
                  v-model="service.FromYear"
                  :items="yearRange"
                  light
                  flat
                  outlined
                  solo
                  dense
                  rounded
                  :label="
                    getString(
                      stepContent,
                      'CVWizard_SecondStep_ChooseYearPlaceHolder'
                    ).Value
                  "
                  prepend-inner-icon="mdi-calendar-range"
                ></v-select>
              </v-col>
              <v-col cols="12" sm="6" class="py-0">
                <p class="display-18 font-weight-medium my-0">
                  {{ getString(stepContent, 'CVWizard_To').Value }}
                </p>
                <v-select
                  v-model="service.ToYear"
                  :items="yearRange"
                  light
                  flat
                  outlined
                  solo
                  dense
                  rounded
                  :label="
                    getString(
                      stepContent,
                      'CVWizard_SecondStep_ChooseYearPlaceHolder'
                    ).Value
                  "
                  prepend-inner-icon="mdi-calendar-range"
                ></v-select>
              </v-col>
            </v-row>
          </v-col>

          <v-col cols="12" sm="6" class="py-0">
            <v-text-field
              v-model="service.Position"
              :label="
                getString(stepContent, 'CVWizard_ForthStep_Position').Value
              "
              solo
              type="text"
              :rules="[]"
              rounded
              :prepend-inner-icon="'mdi-account'"
              :required="false"
              outlined
              dense
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="6" hidden-sm-and-down class="py-0"></v-col>

          <v-col cols="12" sm="12" class="py-0">
            <v-textarea
              v-model="service.Description"
              :label="getString(stepContent, 'CVWizard_Description').Value"
              solo
              type="text"
              :rules="[]"
              rounded
              prepend-inner-icon
              :required="false"
              outlined
              dense
            ></v-textarea>
          </v-col>
        </div>

        <v-col cols="12" sm="12" class="py-0">
          <v-col text-center>
            <v-btn
              tile
              outlined
              x-large
              width="100%"
              class="display-22 cvw-add-btn"
              elevation="0.4"
              @click="addService"
            >
              <v-icon left color="primary">mdi-plus</v-icon>
              {{
                getString(stepContent, 'CVWizard_ForthStep_AddMilitaryService')
                  .Value
              }}
            </v-btn>
          </v-col>
        </v-col>
      </v-row>
      <!-- </ Mil section > -->

      <!-- <Languages> -->

      <v-row>
        <div v-for="(language, i) in languagesData" :key="`language-${i}`">
          <v-col class="pb-0">
            <h3 class="display-26 mb-3">
              {{
                getString(stepContent, 'CVWizard_ForthStep_LanguagesKnowledge')
                  .Value
              }}
            </h3>
          </v-col>
          <v-col cols="12" class="py-0">
            <v-row>
              <v-col cols="12" sm="6" class="py-0">
                <v-text-field
                  v-model="language.Language"
                  :label="
                    getString(stepContent, 'CVWizard_ForthStep_Language').Value
                  "
                  solo
                  type="text"
                  :rules="[]"
                  rounded
                  :prepend-inner-icon="'mdi-web'"
                  :required="false"
                  outlined
                  dense
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" class="py-0">
                <v-select
                  v-model="language.Level"
                  :items="languagesOptions"
                  item-value="Code"
                  item-text="NameInHebrew"
                  :label="
                    getString(stepContent, 'CVWizard_ForthStep_LevelOfControl')
                      .Value
                  "
                  light
                  flat
                  outlined
                  rounded
                  solo
                  class="rtl"
                  small-chips
                  required
                  dense
                />
              </v-col>
            </v-row>
          </v-col>
        </div>
        <v-col cols="12" sm="12" class="py-0">
          <v-col text-center class="py-0">
            <v-btn
              tile
              outlined
              x-large
              width="100%"
              class="display-22 cvw-add-btn"
              elevation="0.4"
              @click="addLanguage"
            >
              <v-icon left color="primary">mdi-plus</v-icon>
              {{
                getString(stepContent, 'CVWizard_ForthStep_AddLanguage').Value
              }}
            </v-btn>
          </v-col>
        </v-col>
      </v-row>

      <!-- </Languages> -->

      <!-- <More Details> -->
      <v-row>
        <v-col cols="12" xs="12">
          <h3 class="display-26">
            {{
              getString(stepContent, 'CVWizard_ForthStep_ExtraDetails').Value
            }}
          </h3>
        </v-col>
        <v-col>
          <v-checkbox
            color="orange"
            v-model="license"
            class="mx-2 my-0"
            :label="
              getString(stepContent, 'CVWizard_ForthStep_DriverLicense').Value
            "
          ></v-checkbox>
          <v-checkbox
            color="orange"
            v-model="discrete"
            class="mx-2 my-0"
            :label="
              getString(stepContent, 'CVWizard_ForthStep_Discretion').Value
            "
          ></v-checkbox>
          <v-checkbox
            color="orange"
            v-model="move"
            class="mx-2 my-0"
            :label="
              getString(stepContent, 'CVWizard_ForthStep_ResidentialCopying')
                .Value
            "
          ></v-checkbox>
          <v-checkbox
            color="orange"
            v-model="relocation"
            class="mx-2 my-0"
            :label="
              getString(stepContent, 'CVWizard_ForthStep_Relocation').Value
            "
          ></v-checkbox>
          <v-checkbox
            color="orange"
            v-model="momJob"
            class="mx-2 my-0"
            :label="getString(stepContent, 'CVWizard_ForthStep_Mother').Value"
          ></v-checkbox>
          <v-checkbox
            color="orange"
            v-model="partial"
            class="mx-2 my-0"
            :label="
              getString(stepContent, 'CVWizard_ForthStep_PartTimeJob').Value
            "
          ></v-checkbox>
          <v-checkbox
            color="orange"
            v-model="references"
            class="mx-2 my-0"
            :label="
              getString(
                stepContent,
                'CVWizard_ForthStep_RecommendationsByDemand'
              ).Value
            "
          ></v-checkbox>
        </v-col>
      </v-row>
      <!-- <More Details> -->
    </v-form>
    <v-row justify="center">
      <v-col class="text-center my-3">
        <v-btn
          color="primary"
          @click="submit()"
          :disabled="!valid"
          rounded
          min-width="120"
          :loading="inProgress"
          >{{
            getString(stepContent, 'CVWizard_ForthStep_CreateCVFile').Value
          }}</v-btn
        >
      </v-col>
    </v-row>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import CvStepsBase from '../base/CvStepsBase.vue'

export default {
  extends: CvStepsBase,
  components: {},

  data() {
    return {
      valid: false,
      wizardStep: 4,
      formSent: false,
      inProgress: false,
      currentStep: 'forthstep',
      nextStep: 'fifthstep',

      serviceData: [
        {
          Service: true,
          Position: '',
          FromYear: null,
          ToYear: null,
          Description: '',
        },
      ],

      languagesData: [
        {
          Language: '',
          Level: '',
        },
      ],

      license: false,
      discrete: false,
      move: false,
      relocation: false,
      momJob: false,
      partial: false,
      references: false,
    }
  },
  mounted() {
    const currentStepNumber = this.$router.currentRoute.params.id

    if (
      currentStepNumber == this.wizardStep &&
      this.isAvailable &&
      this.isLogged
    ) {
      let payload = { stepname: this.currentStep, data: null }
      this.$store
        .dispatch('updateStepperStatus', payload)
        .then(this.mapStoreData())
    }
  },

  computed: {
    ...mapState({
      languagesOptions: (state) => state.cvwizard.content.LanguageOptions,
    }),
  },
  methods: {
    validate() {
      this.$refs.form.validate()
    },
    reset() {
      this.$refs.form.reset()
    },
    resetValidation() {
      this.$refs.form.resetValidation()
    },

    applyServiceTypeField(val, i) {
      this.serviceData[i].Service = val == 1
    },

    addService() {
      this.serviceData.push({
        Service: true,
        Position: '',
        FromYear: null,
        ToYear: null,
        Description: '',
      })
    },
    addLanguage() {
      this.languagesData.push({
        Language: '',
        Level: '',
      })
    },
    submit() {
      var Service = this.getPostDataObjectForService()
      var Languages = this.getPostDataObjectForLanguage()

      let MilitaryExperienceAndAditionalData = {
        '<Service>k__BackingField': Service,
        '<Languages>k__BackingField': Languages,
        '<License>k__BackingField': this.license,
        '<Discrete>k__BackingField': this.discrete,
        '<Move>k__BackingField': this.move,
        '<Relocation>k__BackingField': this.relocation,
        '<MomJob>k__BackingField': this.momJob,
        '<Partial>k__BackingField': this.partial,
        '<References>k__BackingField': this.references,
      }

      let postdata = {
        MilitaryExperienceAndAditionalData: MilitaryExperienceAndAditionalData,
        Save: true,
      }

      let payload = {
        stepname: this.nextStep,
        data: postdata,
      }
      this.inProgress = true

      this.$store.dispatch('updateStepperStatus', payload).then(() => {
        this.$router.push('/קורות-חיים/5/')
      })
    },

    getPostDataObjectForService() {
      let Service = new Array()
      for (var i = 0; i < this.serviceData.length; i++) {
        var element = this.serviceData[i]
        Service.push({
          '<ArmyService>k__BackingField': element.Service,
          '<Position>k__BackingField': element.Position,
          '<FromYear>k__BackingField': element.FromYear,
          '<ToYear>k__BackingField': element.ToYear,
          '<Description>k__BackingField': element.Description,
        })
      }

      return Service
    },

    getPostDataObjectForLanguage() {
      let Languages = new Array()
      for (var i = 0; i < this.languagesData.length; i++) {
        var element = this.languagesData[i]
        Languages.push({
          '<Language>k__BackingField': element.Language,
          '<Level>k__BackingField': element.Level,
        })
      }

      return Languages
    },

    mapStoreData() {
      try {
        if (!_.isEmpty(this.stepData)) {
          this.serviceData = this.stepData.Service
          this.languagesData = this.stepData.Languages
          this.license = this.stepData.License
          this.discrete = this.stepData.Discrete
          this.move = this.stepData.Move
          this.relocation = this.stepData.Relocation
          this.momJob = this.stepData.MomJob
          this.partial = this.stepData.Partial
          this.references = this.stepData.References
        }
      } catch (error) {
        console.log(error)
      }
    },
  },
}
</script>

<style lang="scss" scoped>
#cvw-step-4 .v-input--selection-controls.v-input .v-label {
  margin-right: 15px;
}
</style>
